document.addEventListener("turbo:load", function() {
  $("#accepted_tos").on("click", function () {
    $('#spinner').html(`
      <p class="user__loading">
        <i class="fas fa-spinner user__loading-spinner"></i>
        <span class="user__loading-text">Ihre Daten werden verarbeitet, einen Moment bitte.</span>
      </p>
    `);
});

  $("#accepted_tos").on("click", function () {
    $('#spinner-bnet').html(`
      <p class="bnet-landingpage__loading">
        <span class="bnet-landingpage__loading-text">Deine Daten werden verarbeitet, einen Moment bitte.</span>
      </p>
    `);
  });
})
